import { createContext, useContext, useState } from 'react';
import type { StorageUnit } from 'store/storageunits/types';

type Pos = {
  x: number;
  y: number;
};

type ContextMenuContextProps = {
  pos: Pos;
  open: boolean;
  unit: StorageUnit | null;
  setPos: (pos: Pos) => void;
  openContextMenu: (unit: StorageUnit | null, pos: Pos) => void;
  closeContextMenu: () => void;
};

const ContextMenuContext = createContext<ContextMenuContextProps | null>(null);

export const useContextMenu = () => {
  const context = useContext(ContextMenuContext);
  if (!context) {
    throw new Error('Cannot use hook outside of context');
  }

  return context;
};

const ContextMenuProvider = ({ children }: { children: React.ReactNode }) => {
  const [open, setOpen] = useState(false);
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const [unit, setUnit] = useState<StorageUnit | null>(null);

  const openContextMenu = (unit: StorageUnit | null, newPos: Pos) => {
    setOpen(true);
    setUnit(unit);
    setPos(newPos);
  };

  const closeContextMenu = () => {
    setOpen(false);
    setUnit(null);
    setPos({ x: 0, y: 0 });
  };

  return (
    <ContextMenuContext.Provider
      value={{
        open,
        pos,
        unit,
        setPos,
        openContextMenu,
        closeContextMenu,
      }}
    >
      {children}
    </ContextMenuContext.Provider>
  );
};

export default ContextMenuProvider;
